import { render } from "./NewCustomerModal.vue?vue&type=template&id=50724696&scoped=true"
import script from "./NewCustomerModal.vue?vue&type=script&lang=js"
export * from "./NewCustomerModal.vue?vue&type=script&lang=js"

import "./NewCustomerModal.vue?vue&type=style&index=0&id=50724696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50724696"]])

export default __exports__